import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, API_BASE_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getUsers = (dateRange = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/user/get-all`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const createUserRequest = (userData) =>
  axiosInstance.post(`${ADMIN_API_URL}/user/create`, userData, {
    headers: authHeaders(),
  });

export const updateUserRequest = (userId, userData) =>
  axiosInstance.post(`${ADMIN_API_URL}/user/update/${userId}`, userData, {
    headers: authHeaders(),
  });

export const removeUser = (userId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/user/delete/${userId}`, {
    headers: authHeaders(),
  });

export const getRoles = () =>
  axiosInstance.get(`${API_BASE_URL}/get/roles`, {
    headers: authHeaders(),
  });
